import { render, staticRenderFns } from "./KnDocsGalleryContainer.vue?vue&type=template&id=3cc56bd4&"
import script from "./KnDocsGalleryContainer.vue?vue&type=script&lang=js&"
export * from "./KnDocsGalleryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports